



import { Eye } from "lucide-react";
import moment from "moment";
import { useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { customTableStyles } from "../../../utils/tableStylings";

const DateWiseSalesReportTable = ({ data, onReady }) => {

    const number_format = (number, decimals = 2) => {
        const n = Number(number);
        return n.toLocaleString("en-IN", {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        });
    };

    // ------- Calculate Totals -------
    const totalCount = data.length;

    
    const totalAmount = data.reduce(
        (sum, row) => sum + Number(row?.total_amount || 0),
        0
    );

    const totalDiscount = data.reduce(
        (sum, row) => sum + Number(row?.total_discount || 0),
        0
    );
    const totalTax = data.reduce((sum, row) => {
        let price = Number(row?.total_tax || 0);
        return sum + price;
    }, 0);

    const totalTaxable = data.reduce((sum, row) => {
        let price = Number(row?.total_tax || 0);
        let total = Number(row?.total_amount || 0);

        let taxable = total - price;
        return sum + taxable;
    }, 0);


    const dateWiseSalesColumns = [
        { name: "Date", selector: (row) => moment(row.date).format('DD MMM, YYYY'), sortable: true },
        { name: "Actual Value", selector: (row) => number_format(((Number(row.total_amount) - Number(row.total_tax))) + Number(row.total_discount)), sortable: true },
        { name: "Discount", selector: (row) => number_format(Number(row.total_discount)), sortable: true },
        {
            name: "Taxable Value",
            selector: (row) => number_format((Number(row.total_amount) - Number(row.total_tax)), 2),
            sortable: true,
        },
        {
            name: "Tax Amount",
            selector: (row) => number_format(Number(row.total_tax)),
            sortable: true,
        },
        { name: "Total Amount", selector: (row) => number_format(Number(row.total_amount)), sortable: true },
    ];


    const processedRows = data.map(row => {
        const obj = {};
        dateWiseSalesColumns.forEach(col => {
            obj[col.name] = col.selector(row);
        });
        return obj;
    });

    const totals = {
        "": "",
        "Total Amount": totalAmount,
        "Taxable Value": totalTaxable,
        "Tax Amount": totalTax,
    };


    // FIX HERE — useEffect so it does NOT run every render
    useEffect(() => {
        if (onReady) {
            onReady({ dateWiseSalesColumns, processedRows, totals });
        }
    }, [data]); // run ONLY when data changes


    const statsConfig = [
        {
            label: "Total Count",
            value: totalCount,
            bg: "#EEF2FF",
            color: "#4338CA"
        },
        {
            label: "Total Discount",
            value: number_format(totalDiscount),
            bg: "#ECFEFF",
            color: "#0369A1"
        },
        {
            label: "Total Taxable Value",
            value: number_format(totalTaxable),
            bg: "#FFF7ED",
            color: "#C2410C"
        },
        {
            label: "Total Tax",
            value: number_format(totalTax),
            bg: "#FEF2F2",
            color: "#B91C1C"
        },
        {
            label: "Total Amount",
            value: number_format(totalAmount),
            bg: "#F0FDF4",
            color: "#15803D"
        }
    ];


    const StatsCards = () => (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "repeat(5, 1fr)",
                gap: "20px",
                marginBottom: "15px",
                marginTop: "20px"
            }}
        >
            {statsConfig.map((item, index) => (
                <div
                    key={index}
                    style={{
                    ...cardStyle,
                    backgroundColor: item.bg,
                    borderLeft: `5px solid ${item.color}`
                    }}
                >
                    <div style={{ ...labelStyle, color: item.color }}>
                    {item.label}
                    </div>
                    <div style={{ ...valueStyle, color: item.color }}>
                    {item.value}
                    </div>
                </div>
                ))}
        </div>
    );

    const cardStyle = {
        padding: "15px",
        background: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        border: "1px solid #e5e7eb",
    };

    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        fontWeight: "500",
    };

    const valueStyle = {
        fontSize: "20px",
        fontWeight: "700",
        color: "#111827",
        marginTop: "5px",
    };

    return (
        <>
            <StatsCards />
            <DataTable
                columns={dateWiseSalesColumns}
                data={data}
                pagination={false}
                highlightOnHover
                striped
                dense
                customStyles={customTableStyles}
            />


            {/* Footer Below Table */}

        </>
    );
};

export default DateWiseSalesReportTable;